<nb-card class="nb_card_pop_up full_pop_up mobilePopup" [nbSpinner]="loading">

  <nb-card-header>

    <div class="title">
      <ng-container i18n="@@PlanTemplates">Plan Templates</ng-container>
    </div>

    <div class="actions">
      <button nbButton ghost focus autofocus [disabled]="joyrideService.isTourInProgress()" tabindex="-1">
        <nb-icon icon="close-outline" (click)="Cancel()" style="z-index: 1000;"></nb-icon>
      </button>
    </div>

  </nb-card-header>

  <nb-card-body (scroll)="onScroll($event)" class="select-plan-body">
    <div class="my-3 position-sticky search-box">
      <input nbInput fullWidth #myInput placeholder="Search template name or days" id="input-search"
        (change)="onSearchChange($event)" (keydown.enter)="onSearchChange($event)" />
    </div>
    <div class="d-flex justify-content-between align-items-center header-box">
      <p class="large-checkbox-text"><b>Total: </b>{{templates?.totalCount}}</p>
      <nb-toggle status="basic" [checked]="expandAll" (checkedChange)="onExpandChange()">
        <span class="large-checkbox-text">Collapse all/open all</span></nb-toggle>
    </div>
    <div class="template">
      <form [formGroup]="form" *ngIf="!loading && templates">
        <nb-accordion formArrayName="parents" #accordion [multi]="expandAll" >
          <nb-accordion-item *ngFor="let template of templates?.items; let i = index" [formGroupName]="i" [expanded]="expandAll">
            <nb-accordion-item-header class="justify-content-between">
              <div class="parent-check-box">
              <nb-checkbox class="parent-checkbox" (click)="onCheckboxClick($event)" formControlName="parent"
                [indeterminate]="form.get('parents').controls[i].get('indeterminate').value">
                <span class="large-checkbox-text">{{template.name}}</span>
                </nb-checkbox>
                <p>
                  {{template.description}}
                </p>
              </div>
                <nb-badge *ngIf="template.isPublic" text="Public" status="info" position="right top"></nb-badge>
              <span class="mr-3 total-days">Days: {{template?.thePlan?.days?.length? template?.thePlan?.days?.length:
                0}}</span>
            </nb-accordion-item-header>
            <nb-accordion-item-body formArrayName="children">
              <ng-container
                *ngIf="template?.thePlan && template.thePlan.days && template.thePlan.days.length; else noDays">
                <div class="child-items w-100" *ngFor="let day of template.thePlan.days; let j = index" [formGroupName]="j">
                  <nb-checkbox
                    class="small-checkbox"
                    formControlName="selected"
                  ><span class="small-checkbox-text"></span>{{day.name}}</nb-checkbox>
                </div>
              </ng-container>
              <ng-template #noDays>
                <div>No days for this template!</div>
              </ng-template>
            </nb-accordion-item-body>
          </nb-accordion-item>
        </nb-accordion>
        <div *ngIf="pageLoading" [nbSpinner]="pageLoading"
        nbSpinnerStatus="primary"
        style="height: 50px;"></div>
      </form>
      <div *ngIf="!loading && templates?.totalCount == 0">
       {{searchInput? 'Search returned 0 result' : 'No template found'}}</div>
    </div>
  </nb-card-body>

  <nb-card-footer class="select-template-footer">

    <ng-template #customTutorialContent>
      Select any template from the list and tap the Select Button.
    </ng-template>
      <div class="d-flex footer align-items-center">
          <div [class.in-tutorial]="joyrideService.isTourInProgress()" [class.plan-selected]="SelectedPlan"
            title="Load From Template" class="d-flex bottom-button-box" (next)="SelectPlan()" [joyrideStep]="TutorialIDs.SelectTemplate"
            stepPosition="left" [stepContent]="customTutorialContent">
            <button i18n="@@Select" nbButton type="submit" class="btn-circle btn-xl btn-main" (click)="SelectPlan()"
              [disabled]="totalSelectedDays === 0">Import
            </button>
              <span class="ml-3 selected-days-text align-self-center">Total Selected Days {{totalSelectedDays}}</span>
          </div>
          <div class="append-to-current-plan">
            <nb-checkbox i18n="@@AppendToCurrentPlan" [(ngModel)]="AppendToCurrentPlan">
              <span class="large-checkbox-text">Append to current plan.</span>
            </nb-checkbox>
          </div>
        </div>
  </nb-card-footer>

</nb-card>